<template>
  <v-content>
    <search-view :show-search-options="true"
                 :search-options="getSearchKeys"
                 :show-search-date-options="false"
                 :show-search-date="true"
                 :show-add-button="false"
                 @initEvent="searchEvent"
                 @searchEvent="searchEvent"
                 @reset="reset"></search-view>

    <v-layout>
      <v-radio-group
          v-model="role"
          row
      >
        <v-radio
            label="所有會員"
            :value="-1"
            :color="Theme.GREEN"
        ></v-radio>
        <v-radio
            label="廠商"
            :value="100"
            :color="Theme.GREEN"
        ></v-radio>
      </v-radio-group>
    </v-layout>

    <v-layout>
      <v-flex>
        <table-view :items="list"
                    :columnKeys="getColumnKeys"
                    :pagination="pagination"
                    :loading="loading"
                    @changePage="changePage"
                    @cellEvent="cellEvent"/>
      </v-flex>
    </v-layout>

    <user-detail :title="editView.title" :visible="editView.visible"
                 :item-detail="editView.item"
                 :show-cancel="editView.showCancel"
                 @cancelEvent="editView.cancelEvent"
                 @confirmEvent="editView.confirmEvent"></user-detail>
  </v-content>
</template>

<script>
import SearchView from "@/components/SearchView";
import TableView from "@/components/TableView";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";
import UserDetail from "@/pages/users/UserDetail";
export default {
  name: "Index",
  components: {
    UserDetail,
    TableView,SearchView
  },
  mixins: [common],
  data() {
    return {
      role: -1,
      loading: false,
      searchKey:'',
      searchValue:'',
      startDate: '',
      endDate: '',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list:[],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
      },
    };
  },
  created() {
    this.loadData();
  },
  computed:{
    ...mapGetters([]),
    getColumnKeys(){
      return [
        { value:'edit', text:'編輯' , isEvent: true, color: this.Theme.GREEN, sortable: false },
        { value:'email', text:'Email', sortable: true },
        { value:'name', text:'姓名', sortable: true },
        { value:'cellphone', text:'電話', sortable: false },
        // { value:'country', text:'國家', sortable: false, options: this.getCountryType, },
        { value:'city', text:'城市', sortable: false },
        // { value:'gender', text:'性別', sortable: false , options: this.getGender},
        { value:'role', text:'角色', sortable: false , options: this.getRoleList},
        // { value:'birthday', text:'生日', sortable: true },
        // { value:'tag', text:'', sortable: true },
        // // { value:'sort', text:'排序', sortable: false },
        { value:'point', text:'代幣', sortable: false },
        { value:'bonus', text:'紅利', sortable: false },
        { value:'createdDate', text:'註冊時間', sortable: false },
        // { value:'status', text:'上架狀態', sortable: false, options: this.getProductEnable },
        // { value:'delete', text:'刪除' , isEvent: true, color: this.Theme.YELLOW, sortable: false },
      ]
    },
    getSearchKeys() {
      return [
        { key: "email", value: "Email" },
        { key: "name", value: "姓名" },
        { key: "cellphone", value: "電話" },
      ];
    },
  },
  methods:{
    ...mapActions(['getUserList']),
    async loadData(){
      try {
        let searchQuery = [];
        if (this.searchKey !== '' && this.searchValue !==''){
          searchQuery.push({ key:this.searchKey , value: this.searchValue });
        }

        if (this.role > 0){
          searchQuery.push({ key:'role' , value: this.role });
        }

        this.loading = true;
        const res = await this.getUserList({
          pageIndex: this.pagination.page,
          limit: this.pagination.itemsPerPage,
          startDate: `${this.startDate} 00:00:00`,
          endDate: `${this.endDate} 23:59:59`,
          searchQuery: searchQuery,
        });

        if (res.data.statusCode === 0){
          this.list = res.data.data.list;
          this.pagination.totalItems = res.data.data.header.totalCount;

          console.log(`getUserList ${JSON.stringify(res.data.body.list)}`);
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page){
      this.pagination.page = page.page;
      if (page.itemsPerPage === -1){
        this.pagination.itemsPerPage = 1000;
      } else {
        this.pagination.itemsPerPage = page.itemsPerPage;
      }
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell){
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === 'delete'){
        this.showAlert({
          title: '提示',
          content: '是否確定要刪除此會員？',
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteEvent(cell.item);
          }
        });
      } else {
        if (!cell.item.imageList) {
          cell.item.imageList = [];
        }
        // if (!cell.item.linkList) {
        //   cell.item.linkList = [];
        // }

        this.editView.title = cell.key === 'add' ? '新增會員':'修改會員'
        this.editView.item = cell.item;
        this.editView.visible = true;
        this.editView.cancelEvent = ()=>{
          this.editView.visible = false;
        }
        this.editView.confirmEvent = ()=>{
          this.editView.visible = false;
          this.loadData();
        }
      }

    },
    searchEvent(info){
      this.startDate = info.startDate;
      this.endDate = info.endDate;
      this.searchKey = info.searchKey;
      this.searchValue = info.searchValue;

      this.loadData();
    },
    reset(){
      this.searchValue = '';
      this.loadData();
    },
    // async deleteEvent(item){
      // const res = await this.deleteProductInfo({
      //   isDelete: true,
      //   productId: item.productId,
      // });
      //
      // if (res.data.statusCode === 0){
      //   this.reset();
      // }
    // },
  }
}
</script>

<style scoped>

</style>
